export const version = "ethers/5.0.31";
//# sourceMappingURL=_version.js.map